//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import ptFightcampTrackers from '~/components/products/content/pt_fightcamp_trackers';
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';

export default {
  name: 'partner-offer',
  head: {
    ...metaData.trackers,
  },
  async asyncData({ $storyapi, error }) {
    const storyBlok = new CMSService({ cmsService: $storyapi });

    try {
      const storyblokData = await storyBlok.get('partner-offer', { resolve_relations: 'ReviewsGrid.reviews' });

      return {
        storyRespId: storyblokData?.data?.story?.id || [],
        storyResp: storyblokData?.data?.story?.content || [],
      };
    } catch (e) {
      error({ message: e.message });
      return {};
    }
  },
  computed: {
    ...mapGetters([
      'isInStoryblok',
    ]),
  },
  mounted() {
    this.$ecommAnalytics.view_item([{
      item_id: ptFightcampTrackers.id,
      item_name: ptFightcampTrackers.title,
      price: ptFightcampTrackers.product.price,
      item_category: ptFightcampTrackers.category,
    }]);
    this.$analytics.productViewed(ptFightcampTrackers);

    if (this.isInStoryblok) {
      this.$storybridge(
        () => {
          const { storyblok } = window;
          if (storyblok != null) {
            storyblok.on(['input', 'published', 'change'], (event) => {
              if (event?.action === 'input') {
                if (event.story.id === this.storyRespId) {
                  this.storyResp.body = event.story.content.body;
                }
              } else {
                window.location.reload();
              }
            });
          }
        },
        (error) => {
          console.error(error);
        },
      );
    }
  },
};
